import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	fileVsRegulatorColumn,
	licenseColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters, ownAccountsScopeRule } from '../filter-rules';

/**
 * Link Ended — active buyers' confirmed licenses whose regulator link to
 * another license the client holds has ended (match_signals.link_ended_at,
 * written by the nightly link-drift stage). The match is kept on purpose: a
 * person decides whether the license still belongs to the account, so the
 * action opens the license. Same predicate as the dashboard's Link Ended card.
 */
export const linkEndedComplianceList: ListBuilderList = {
	id: 'compliance-link-ended',
	cacheTTL: 300000,
	// Tab label, deliberately short: the tabs must fit the Needs Attention
	// strip at 1440px before the More dropdown swallows them (Chris,
	// 2026-09-20). The full name is above and on the dashboard card.
	name: 'Link Ended',
	type: 'default',
	active: true,
	sortOrder: 6,
	filterRules: {
		...hideOtherCardFilters(['licenseLinkEnded']),
		licenseSalesRep: ownAccountsScopeRule,
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseLinkEnded: {
			defaultValue: [{ id: 'yes', label: 'Yes' }],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		fileVsRegulatorColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
